module.exports = {"440803001":"解放街道","440803002":"爱国街道","440803003":"工农街道","440803004":"友谊街道","440803005":"新兴街道","440803006":"海滨街道","440803009":"建设街道","440803010":"东新街道","440803011":"新园街道","440803012":"海头街道","440803070":"泉庄街道","440803071":"乐华街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440803.json
// module id = 1998
// module chunks = 0